import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Loader2, Link2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

// Attach a Creator Core /client/ dashboard as a SECONDARY source. Never replaces the
// campaign's existing (e.g. G*) source link — both stay refreshable into the same campaign.
export function CreatorCoreSourceDialog({ open, onOpenChange, campaignId, current, onStarted }) {
  const [url, setUrl] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setUrl(current || ""); }, [open, current]);

  const submit = async () => {
    const u = url.trim();
    if (!u) return toast.error("Paste a Creator Core client link");
    setSaving(true);
    try {
      const { data } = await api.post(`/campaigns/${campaignId}/sources/creatorcore`, { url: u });
      onOpenChange(false);
      onStarted?.(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="creatorcore-source-dialog" className="max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Creator Core link</DialogTitle>
          <DialogDescription>
            Add a Creator Core client dashboard to this campaign. Its posts are pulled from the live cards and merged in by post URL — your existing source link and other posts are left untouched.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Creator Core client URL</Label>
            <Input
              data-testid="input-creatorcore-url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="mt-1"
              placeholder="https://name.creatorcore.co/client/..."
            />
          </div>
          <Button data-testid="submit-creatorcore-source" onClick={submit} disabled={saving} className="w-full rounded-full bg-[#35606E] py-6 hover:bg-[#294b57]">
            {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Link2 className="mr-2 h-4 w-4" />} Save & pull posts
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
